import React, { useEffect, useState } from "react"
import { useNavigate, Link } from "react-router-dom";
import WOW from "wowjs";
import "animate.css";
import Map from '../images/graph-image.png'
import { REGISTRATION_ABI, REGISTRATION_ADDRESS, MATRIX_CONTRACT, MATRIX_ABI } from '../constants/contract'
import useWalletConnect from "../hooks/useWalletConnect";
import { Contract, isAddress } from "ethers";
import contractErrorHandler from "../hooks/contractErrorHandler";
import { useUser } from "../context/UserContext";
import waves from '../images/waves.png'
import InnerHeader from '../components/InnerHeader'
import logo from '../images/logo.png'
import Slot from '../components/Slot'
const Slots = () => {

    const navigate = useNavigate();
    const { setUser, userData } = useUser();


    if (!userData) navigate('/register')

    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    function trimAddress(address, length = 4) {
        if (!address) return '';
        return `${address.slice(0, 2 + length)}...${address.slice(-length)}`;
    }

    useEffect(() => {
        new WOW.WOW().init();
    }, []);

    const { parseError } = contractErrorHandler();




    const {
        account,
        connectBrowserWallet,
        connectWalletConnect,
        disconnectWallet,
        connectionType,
        loading,
        signer
    } = useWalletConnect();


    const copyText = () => {
        navigator.clipboard.writeText("https://markman.pro/register?ref=" + account.address);
        alert('Copied Referral Link Successfully')
    };

    const [isLoading, setIsLoading] = useState(false);

    const [pkgCounts, setPkgCounts]=useState([])
    useEffect (() =>{
         async function loadData(){
           try {
                    if (!signer) return;

                    const contract = new Contract(MATRIX_CONTRACT, MATRIX_ABI, signer);
        
                   
                       for(var i=1; i<12; i++){
                        const pkgUsers=await contract.getPkgCount(i)
                       
                        setPkgCounts(prev => [...prev, pkgUsers]);

                       }
                
        
                } catch (err) {
                    setError(parseError(err))
                    console.log(err)
                } finally {
                    setIsLoading(false);
                }
            }

            loadData()
    },[signer])
    return (
        <>
            <InnerHeader />

            <section className="bg-secondary-100" >

                <div className="h-fit py-10  px-4 md:px-6">

                    <div className="pt-20" >

                        <div className="grid grid-cols-12" >

                            <div className="col-span-12 md:col-span-1"></div>

                            {/*     <div className="col-span-12 md:col-span-2 lg:col-span-2 px-3">

                                <div className="bg-secondary-200 p-3 rounded-xl mb-3 pl-5 text-gray text-xs">
                                    Dashboard <i className="fa fa-arrow-right"></i>
                                </div>

                                <div className="bg-secondary-200 p-3 rounded-xl mb-3 pl-5 text-gray text-xs">
                                    Dashboard <i className="fa fa-arrow-right"></i>
                                </div>

                            </div>
                             */}
                            <div className="col-span-12 md:col-span-10">
                                
                        <div className="grid grid-cols-12" >
                                <Slot signer={signer} level="1" totalUsers={pkgCounts[0]} amount="5" account={account}/>

                                <Slot signer={signer} level="2"totalUsers={pkgCounts[2]} amount="8"account={account}/>

                                <Slot signer={signer} level="3" totalUsers={pkgCounts[3]} amount="18"account={account}/>

                                <Slot signer={signer} level="4" totalUsers={pkgCounts[4]}amount="40"account={account}/>

                                <Slot signer={signer} level="5" totalUsers={pkgCounts[5]}amount="80"account={account}/>

                                <Slot signer={signer} level="6" totalUsers={pkgCounts[6]}amount="160" account={account}/>


                                <Slot signer={signer} level="7" totalUsers={pkgCounts[7]}amount="320" account={account}/>

                                <Slot signer={signer} level="8" totalUsers={pkgCounts[8]}amount="640" account={account}/>

                                <Slot signer={signer} level="9" totalUsers={pkgCounts[9]}amount="1280" account={account}/>

                                <Slot signer={signer} level="10" totalUsers={pkgCounts[10]}amount="2560" account={account}/>

                                <Slot signer={signer} level="11" totalUsers={pkgCounts[11]}amount="5120" account={account}/>

                                </div>
                            </div>


                        </div>
                    </div>

                </div>
            </section>


        </>

    )
}

export default Slots;